import React, { useState, useEffect } from 'react';
import { Chart } from 'react-chartjs-2';
import validate from 'validate.js';
import Amplify from '@aws-amplify/core'
import { AmplifySignIn, AmplifyAuthenticator } from '@aws-amplify/ui-react'
import { AuthState, onAuthUIStateChange } from '@aws-amplify/ui-components'
import { chartjs } from './helpers';
import { API_NAME } from './const'
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';
import { useCurrentUserUpdate } from "hooks/useCurrentUserUpdate"
import { usePageAccessRestriction } from "hooks/usePageAccessRestriction"
import { Maintenance } from './views'

console.log('REACT_APP_API_URL');
console.log(process.env.REACT_APP_API_URL);

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID, //REQUIRED - Amazon Cognito Identity Pool ID
    region: 'ap-northeast-1',
    userPoolId: process.env.REACT_APP_USER_POOL_ID, // OPTIONAL - Amazon Cognito User Pool ID
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID, // OPTIONAL - Amazon Cognito Web Client ID
  },
  API: {
    endpoints: [
      {
        name: API_NAME,
        endpoint: process.env.REACT_APP_API_URL,
        region: 'ap-northeast-1',
      },
    ],
  },
})

const App = () => {
  const [authState, setAuthState] = useState()

  useEffect(() => {
    return onAuthUIStateChange((nextAuthState) => {
      setAuthState(nextAuthState)
    })
  }, [])

  // ロケーション変更毎にユーザ情報を取得する
  useCurrentUserUpdate(authState)

  // ロケーションのアクセス権限チェック
  usePageAccessRestriction()

  return (
    <>
      {Number(process.env.REACT_APP_MAINTENANCE_FLAG) === 1 ? (
        <>
          <Maintenance />
        </>
      ) : authState === AuthState.SignedIn ? (
        <>
          <Routes />
        </>
      ) : (
        <AmplifyAuthenticator>
          <AmplifySignIn slot="sign-in" hideSignUp={true} />
        </AmplifyAuthenticator>
      )}
    </>
  )
}
export default App;
